(ns app.survey.select-survey
  (:require
   [app.survey.event :as event]
   [app.survey.processing :as processing]
   [app.survey.sub :as sub]
   [common.dates :as c-date]
   [common.dates :as dates]
   [common.localization :as loc]
   [ui.util :as uu]
   [re-frame.core :as rf]
   [ui.components.alert-list.view :as alert-list]
   [ui.components.button.view :as button]))

(defn no-access
  []
  [:div
   {:class "h-full flex flex-col gap-6 justify-center items-center"}
   [:h2
    (loc/tr :no-access-to-any-surveys)]
   [button/secondary-hollow
    {:on-click #(rf/dispatch [::event/logout])}
    (loc/tr :logout)]])

(defn view
  []
  (let [accessible-surveys @(rf/subscribe [::sub/accessible-surveys])
        processing? @(rf/subscribe [::sub/processing?])]
    [:div
     {:class "position-fixed w-full h-full flex flex-col flex-1 bg-base-light"}
     [alert-list/view :login-notifications]
     (if processing?
       [processing/view]
       [:div
        {:class "flex flex-col h-full"}
        (if (empty? accessible-surveys)
          [no-access]
          [:<>
           [:div 
            {:class "px-4 w-full flex flex-col flex-1 gap-3 overflow-y-auto"}
            [:div 
             {:class "max-w-[1024px] w-full mx-auto"}
             [:h2
              {:class "py-4 flex gap-2 text-xl font-semibold"}
              (loc/tr :login-available-surveys)]
             [:ul
              {:class "flex flex-col flex-1"}
              (some->>
               accessible-surveys
               (map (fn [s]
                      ^{:key (str "survey-item-" (:id s))}
                      [:li
                       {:class    (uu/cm "grid grid-cols-10 py-2 px-2 gap-4
                                                                 text-complement-light-text
                                                                 border-b border-solid border-base-light-border-paler"
                                         "hover:bg-base-regular pointer"
                                         "align-items-center")
                        :on-click #(rf/dispatch [::event/select-survey (:id s)])}
                       [:div
                        {:class "flex items-baseline gap-3 col-span-5 md:col-span-6"}
                        [:span
                         {:class "text-info-regular"}
                         [:i.fa-duotone.fa-thin.fa-ballot-check]]
                        [:div
                         {:class "flex flex-auto flex-col"}
                         (:label s)]]
                       [:div
                        {:class "grid grid-cols-2 gap-4 align-items-center col-span-5 md:col-span-4"}
                        [:div
                         {:class "text-xs m-0"}
                         (when-let [start-ts (:timestamp-period-start s)]
                           (let [end-ts (:timestamp-period-end s)
                                 start-of-month (c-date/date-time start-ts)
                                 end-of-month (c-date/date-time end-ts)]
                             (str (when-not (= end-ts start-ts)
                                    (c-date/format start-of-month {:pattern "dd.MM"}))
                                  (when-not (= end-ts start-ts)
                                    " - ")
                                  (c-date/format end-of-month {:pattern "dd.MM.yyyy"}))))
                         (when-let [invite-date-ms (:invite-date s)]
                           (dates/format (dates/date invite-date-ms)
                                         {:format "d-MMM-yyyy"}))]
                        [:div
                         {:class "flex justify-end"}
                         [:div
                          {:class (uu/cm "px-4 py-1 rounded-full text-xs font-semibold"
                                         (case (:status s)
                                           :survey-process.status/wip "bg-info-light bg-text-info-light-text border border-info-light-border-paler text-info-light-text"
                                           :survey-process.status/draft "bg-warning-light bg-text-warning-light-text border border-warning-light-border"
                                           :survey-process.status/prefilled "bg-warning-light bg-text-warning-light-text border border-warning-light-border"
                                           "bg-primary-light bg-text-primary-light-text border border-primary-light-border"))}
                          (case (:status s)
                            :survey-process.status/wip (loc/tr :survey-status-wip)
                            :survey-process.status/draft (loc/tr :survey-status-waiting)
                            :survey-process.status/prefilled (loc/tr :survey-status-waiting)
                            (loc/tr :survey-status-review-submission))]]]]))
               (doall))]]]
           [:div
            {:class "w-full pt-3 max-w-[1024px] mx-auto my-3 flex justify-end gap-2 text-center border-t border-solid border-base-regular-border-paler"}
            [button/primary-solid
             {:on-click #(rf/dispatch [::event/logout])}
             (loc/tr :logout)]]])])]))
